import { render, staticRenderFns } from "./verifyEmail.vue?vue&type=template&id=278a6cc7"
import script from "./verifyEmail.vue?vue&type=script&lang=js"
export * from "./verifyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports